<template>
    <div class="order-status-graphic" v-if="order">
        <div class="status-row" v-for="(stage, index) in stages" :key="stage.status">
            <div class="status-icon">
                <order-status-graphic-icon
                    :status="getOrderIconStatus(stage.status)"
                    :is-last="index === stages.length - 1"
                />
            </div>
            <div class="status-description">{{ stage.title }}</div>
        </div>
    </div>
</template>

<script>
import OrderStatusGraphicIcon from "./order-status-graphic-icon";
import orderStatusHelper from "@/helpers/order-status";

const STAGES = ['SUBMITTED', 'APPROVED', 'ORDERING', 'ORDERED', 'INSTOCK', 'DELIVERING', 'DELIVERED'];

export default {
    name: "order-status-graphic",
    components: { OrderStatusGraphicIcon },
    props: ['order', 'product'],
    computed: {
        orderStatus() {
            return orderStatusHelper.key2StatusToOrigoStatus(this.order.orderStatusDescription, false);
        },
        stages() {
            return STAGES.map(status => ({
                status,
                title: orderStatusHelper.origoStatusToStatusTitle(status),
            }));
        }
    },
    methods: {
        getOrderIconStatus(stage) {
            const currentIndex = STAGES.indexOf(this.orderStatus);
            const stageIndex = STAGES.indexOf(stage);

            if (stageIndex === currentIndex) return 'current';
            if (stageIndex < currentIndex) return 'completed';
            return null;
        }
    }
}
</script>

<style scoped lang="scss">
    .order-status-graphic {
        position:relative;
        z-index:1;

        &:before {
            content: "";
            width: 1px;
            display: block;
            height: 87%;
            background: black;
            position: absolute;
            top: 5%;
            left: 38px;
            z-index: 0;
            opacity: 0.1;
        }

        .status-row{
            position: relative;
            z-index: 1;
            display: flex;
            padding: 1rem;
            justify-content: flex-start;
            align-items: center;

            .status-description {
                margin-left: 1.5rem;
            }
        }
    }
</style>
